import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  setPageTitle,
  toggleNavigation,
  setMessage,
  setBreadCrum,
  toggleBreadcrum,
} from "../../../store/Page";

import OutboundCampaignList from "./OutboundCampaignList";
import { OutboundSMSCampaignList } from "../OutboundSMS";
import TrustHubComplianceForm from "../TrustHub/TrustHubComplianceForm";
import api from "../../../api";
import ComingSoon from "./ComingSoon";
import constants from "../../../util_funs/constant";

const OutboundCampaign = (props) => {
  const { setPageTitle, toggleNavigation, toggleBreadcrum, user } = props;

  const [profileStatus, setProfileStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [voiceTab, setVoiceTab] = useState("active");
  const [smsTab, setSmsTab] = useState("");

  useEffect(() => {
    setPageTitle({ title: "Outbound Campaign", subHeaderTitle: "Campaigns" });
    toggleNavigation({ toggle: true });
    toggleBreadcrum({ toggle: false });
    getProfileStatus();
  }, []);

  const getProfileStatus = async () => {
    try {
      setLoading(true);
      const response = await api.trustHub.getProfileStatus(user.user_id);
      const { profileStatus } = response.data || {};
      setProfileStatus(profileStatus);
    } catch (err) {
      console.error("Error fetching profile status:", err);
      setProfileStatus(null);
    } finally {
      setLoading(false);
    }
  };

  const toggleTab = (tab) => {
    if (tab === "voice") {
      setVoiceTab("active");
      setSmsTab("");
    } else if (tab === "sms") {
      setVoiceTab("");
      setSmsTab("active");
    }
  };

  // 🔹 Wait while loading or no status yet
  if (loading || profileStatus === null) {
    return <div className="ui active inline loader" style={{ margin: "50px auto" }}></div>;
  }

  // 🔹 Helper function to format status
  const formatStatus = (status) => {
    if (!status) return '';
    if (status === 'approved' || status === 'twilio-approved') return 'Completed';
    if (status === 'not_created') return 'Not Created';
    return status
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // 🔹 Check if profile is approved
  const isTwilioApproved = profileStatus === 'twilio-approved';

  // 🔹 If profile is not approved, show message without tabs
  if (!isTwilioApproved) {
    const isDraft = profileStatus === 'draft';
    const isNotCreated = !profileStatus || profileStatus === 'not_created';

    let messageText = '';
    let actionText = '';
    let actionIcon = '';

    if (isDraft) {
      messageText = 'Your business profile is in draft status. Please complete and submit your profile to enable outbound voice campaigns.';
      actionText = 'Update Business Profile';
      actionIcon = 'la-edit';
    } else if (isNotCreated) {
      messageText = 'You need to create a business profile to access outbound voice campaign features.';
      actionText = 'Create Business Profile';
      actionIcon = 'la-plus';
    } else {
      messageText = `Your business profile is currently ${formatStatus(profileStatus)}. Approval is required to create and run outbound voice campaigns.`;
      actionText = 'View Business Profile';
      actionIcon = 'la-eye';
    }

    return (
      <div className="kt-container kt-body kt-grid kt-grid--ver cancelBillUi" id="kt_body">
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
          <div className="kt-content kt-grid__item kt-grid__item--fluid yr-body-p">
            <div style={{
              padding: '40px 20px',
              margin: '40px auto',
              maxWidth: '900px',
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                borderColor: 'rgb(222, 226, 230)',
                backgroundColor: 'rgb(248, 249, 250)',
                padding: '0.75rem 1rem',
                borderRadius: '0.25rem',
                marginBottom: '1rem',
                border: '1px solid rgb(222, 226, 230)',
                flexDirection: 'column',
                textAlign: 'center',
                gap: '15px'
              }}>
                <div style={{
                  fontSize: '48px',
                  color: '#6c757d'
                }}>
                  <i className="la la-shield-alt"></i>
                </div>
                <div style={{ width: '100%' }}>
                  <h3 style={{
                    color: '#495057',
                    marginBottom: '10px',
                    fontSize: '20px',
                    fontWeight: 600
                  }}>
                    Business Profile Approval Required
                  </h3>
                  <p style={{
                    color: '#6c757d',
                    fontSize: '14px',
                    lineHeight: '1.6',
                    margin: '0 auto 10px'
                  }}>
                    {messageText}
                  </p>
                  <p style={{
                    color: '#6c757d',
                    fontSize: '13px',
                    marginBottom: '15px'
                  }}>
                    Current Status: <strong>{formatStatus(profileStatus) || 'Not Created'}</strong>
                  </p>
                  <a
                    href="/trust-hub"
                    className="linear-gradient yr-submitbtn btn-sm"
                    style={{
                      padding: '10px 25px',
                      fontSize: '14px',
                      textDecoration: 'none',
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                  >
                    <i className={`la ${actionIcon}`}></i> {actionText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 🔹 If profile is approved - show tabbed interface
  return (
    <div className="kt-container kt-body kt-grid kt-grid--ver cancelBillUi" id="kt_body">
      <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-content kt-grid__item kt-grid__item--fluid yr-body-p">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="kt-portlet kt-portlet--mobile" style={{ boxShadow: "none" }}>
                <div className="kt-portlet kt-portlet--tabs yr-mt-20 shadow-none">
                  <div className="kt-portlet__head">
                    <div className="kt-portlet__head-toolbar">
                      <ul
                        className="nav nav-tabs nav-tabs-line nav-tabs-line-success nav-tabs-line-3x"
                        role="tablist"
                      >
                        <li className="nav-item">
                          <a
                            className={"nav-link " + voiceTab}
                            data-toggle="tab"
                            role="tab"
                            onClick={() => toggleTab("voice")}
                            style={{ cursor: "pointer" }}
                          >
                            Outbound Voice
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={"nav-link " + smsTab}
                            data-toggle="tab"
                            style={{ cursor: "pointer" }}
                            role="tab"
                            onClick={() => toggleTab("sms")}
                          >
                            {constants.OUTBOUND_SMS}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="kt-portlet__body kt-portlet__body--fit">
                    <div className="tab-content">
                      <div
                        className={"tab-pane " + voiceTab}
                        id="outbound_voice_tab"
                        role="tabpanel"
                      >
                        <OutboundCampaignList user={user} profileStatus={profileStatus} />
                      </div>
                      <div
                        className={"tab-pane " + smsTab}
                        id="outbound_sms_tab"
                        role="tabpanel"
                      >
                        <OutboundSMSCampaignList user={user} profileStatus={profileStatus} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
//    return (
//   <div
//     className="kt-container kt-body kt-grid kt-grid--ver cancelBillUi"
//     id="kt_body"
//   >
//     <div className="yr-body-p" style={{ margin: "10px" }}>
//       <div
//         style={{
//           padding: "0 20px",
//           marginTop: "40px",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <ComingSoon title="Outbound Campaigns" />
//       </div>
//     </div>
//   </div>
// );
};

const mapStateToProps = (state) => ({
  user: state.user.company,
});

const mapDispatchToProps = {
  setPageTitle,
  toggleNavigation,
  setMessage,
  setBreadCrum,
  toggleBreadcrum,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutboundCampaign));
